import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { Facebook, Instagram, Twitter, YouTube, Phone, Email, Place, WhatsApp } from "@mui/icons-material";

export default function Footer() {
  const location = useLocation();
  const [termsUrl, setTermsUrl] = useState("/terminos-condiciones");
  const [privacyUrl, setPrivacyUrl] = useState("/terminos-condiciones");

  useEffect(() => {
    if (/\/empresa[s]?\/?/i.test(location.pathname)) {
      setTermsUrl("/terminos-condiciones-empresa");
    } else if (/\/buscador(-de)?-empleo\/?/i.test(location.pathname)) {
      setTermsUrl("/terminos-condiciones-bde");
    } else {
      setTermsUrl("/");
    }
  }, [location]);

  useEffect(() => {
    if (/\/empresa[s]?\/?/i.test(location.pathname)) {
      setPrivacyUrl("/aviso-privacidad-empresa");
    } else if (/\/buscador(-de)?-empleo\/?/i.test(location.pathname)) {
      setPrivacyUrl("/aviso-privacidad-bde");
    } else {
      setPrivacyUrl("/");
    }
  }, [location]);

  return (
    <FooterContainer>
      <FooterContent>
        <LeftSection>
          <LogoContainer>
            <LogosGuanajuato>
              <a href="https://www.guanajuato.gob.mx/">
                <img src={`${process.env.REACT_APP_CLOUDFRONT_IMAGES}/nuevos-logotipos/gobierno_de_la_gente.webp`} alt="Guanajuato" />
              </a>
              <a href="https://www.optimen.com.mx/">
                <img src={`${process.env.REACT_APP_CLOUDFRONT_IMAGES}/logos/logo-TMF-negro1.png`} alt="Tech Mind Factory" />
              </a>
            </LogosGuanajuato>
          </LogoContainer>
          <InfoGrid>
            <InfoBlock>
              <h3>ATENCIÓN CIUDADANA</h3>
              <p><Phone fontSize="small" /> 800 465 2486</p>
              <p><WhatsApp fontSize="small" /> 800 465 2486</p>
              <p><Email fontSize="small" /> contacto@guanajuato.gob.mx</p>
              <p className="pt-4">¿Existe algún problema con esta página? <a href="#">Repórtalo aquí</a>.</p>
            </InfoBlock>
            <InfoBlock>
              <h3>NUESTRA SEDE</h3>
              <p><Place fontSize="small" /> Paseo de la Presa 103, Centro, C.P. 36000, Guanajuato, GTO.</p>
            </InfoBlock>
            <SocialMedia>
              <h3>SÍGUENOS EN NUESTRAS REDES</h3>
              <SocialIcons>
                <IconLink href="https://instagram.com/gobgente" target="_blank"><Instagram fontSize="medium" /> @gobgente</IconLink>
                <IconLink href="https://facebook.com/gobgente" target="_blank"><Facebook fontSize="medium" /> @gobgente</IconLink>
                <IconLink href="https://twitter.com/gobgente" target="_blank"><Twitter fontSize="medium" /> @gobgente</IconLink>
                <IconLink href="https://youtube.com/gobgente" target="_blank"><YouTube fontSize="medium" /> @gobgente</IconLink>
              </SocialIcons>
            </SocialMedia>
          </InfoGrid>
        </LeftSection>
      </FooterContent>
      <FooterBottom>
        <p> &copy; {new Date().getFullYear()} Gobierno del Estado de Guanajuato</p>
        <p><a href={privacyUrl}>Aviso legal</a> - <a href={termsUrl}>Terminos y condiciones</a></p>
      </FooterBottom>
    </FooterContainer>
  );
}

const FooterContainer = styled.footer`
  background-color: #C8D8EB;
  color: #004B87;
  width: 100%;
  max-width: 100vw;
  overflow: hidden;
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  h3 {
    font-size: 20px;
    margin-bottom: 10px;
  }
`;

const FooterContent = styled.div`
  width: 90%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LeftSection = styled.div`
  width: 100%;
`;

const LogoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 20px;

  img {
    height: 4rem;
  }

  @media (max-width: 860px) {
    flex-direction: column;
    align-items: center;
  }
`;

const LogosGuanajuato = styled.div`
  display: flex;
  gap: 20px;
`;

const InfoGrid = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 30px;

  @media (max-width: 860px) {
    flex-direction: column;
    align-items: center;
  }
`;

const InfoBlock = styled.div`
  text-align: left;
  max-width: 300px;

  @media (max-width: 860px) {
    text-align: center;
  }
`;

const OptimenSection = styled.div`
  padding-top: 20px;
  text-align: right;

  img {
    height: 3rem;
  }
  p{
    font-size: 12px;
  }
`;

const SocialMedia = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;

  @media (max-width: 860px) {
    align-items: center;
    text-align: center;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const IconLink = styled.a`
  color: #004B87;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: color 0.3s;
  &:hover {
    color: #69B3E7;
  }
`;

const FooterBottom = styled.div`
  text-align: center;
  font-size: 13px;
  color: #555;
  width: 100%;
  padding-top: 20px;
`;